import { useEffect, useState, useCallback } from "react";
import { api } from "../api";

/**
 * Read-only view of an environment's shared memory (what the agent has
 * remembered). Scoped to the active environment.
 */
export function useEnvironmentMemory(envId) {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!envId) { setMemories([]); return; }
    setLoading(true);
    try {
      setMemories(await api.listEnvironmentMemory(envId));
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [envId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { memories, loading, error, refresh };
}
